export enum Position {
	Single,
	Start,
	Middle,
	End,
}
